import React from "react";
import BillingInformationHeader from "./BillingInformationHeader";

const CancelInAppSubscription = (props: { appStoreURL: string; paymentTypeMessage: string }) => {
    return (
        <React.Fragment>
            <div className="box-header">
                <BillingInformationHeader />
            </div>
            <div className="box-content">
                <div role="grid" className="data-grid " id="billing-grid" aria-hidden="false">
                    <div role="row" className="data-row row">
                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                            <div className="data-value" aria-labelledby="label-billing-payment-history">
                                <a href={props.appStoreURL} className="default_link">
                                    {"Cancel this subscription on " + props.paymentTypeMessage + " Store"}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CancelInAppSubscription;
